export default __webpack_public_path__ + "static/media/globe-icon.e82041f4.svg";